// TODO: Import React module
//import * as React from 'react';

// TODO: Return today date
//const date = new Date();
//export const Today = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
export const GetNow = () => {
    const date = new Date();
    return `${date.getFullYear()}-${String((date.getMonth() + 1)).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
};

// TODO: Fetch Data
export const FetchData = (url, formData, callback) => {
    (async () => {
        fetch(
            url,
            {
                method: 'POST',
                body: formData,
            }
        )
            .then((response) => response.json())
            .then((result) => {
                callback(result);
            })
            .catch((error) => {
                console.error('Error:', error);
                return false;
            });
    })();
}